import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToFairePosCTA } from "./shared";

export const UnlinkingPosIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getGoToFairePosCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getGoToFairePosCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UNLINKING_POS(strictLocalize),
    getDescription: () => [
      TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize),
      TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize),
    ],
  };
};

const UNLINKING_POS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Unlinking POS",
    description: {
      text: "Title for the answer of Unlinking POS issue",
    },
  });

const TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can disconnect your current POS integration by clicking the user-icon button in the upper-right corner of the retailer portal and selecting the “My [INTEGRATION NAME] POS” option. On this page, in the top right hand corner click on “Settings”. Once you are in your Settings, you can scroll down to “Disconnect [INTEGRATION NAME] POS”.",
  });

const TO_RECONNECT_A_DIFFERENT_ACCOUNT = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "To reconnect a different account, you can refresh the page and simply click on “Connect to Square”, “Connect to Shopify” or “Connect to Clover”.",
    description: {
      text: "Description for the answer of Unlinking POS issue. POS stands for Point of Sale.",
    },
  });
